export default {
  header: {
    subtitle: 'Évaluation de votre besoin en ligne',
  },
  menus: {
    loading: 'Chargement',
    delivery: 'Livraison',
    serviceOffer: 'Prestations',
    estimationPrice: 'Prix estimé',
    furnitures: 'Inventaire',
    result: 'Validation',
    loadingAddress: 'Adresse',
    loadingHousing: 'Logement',
    loadingFloor: 'Étages',
    loadingElevator: 'Ascenseur',
    loadingFurnitureTransport: 'Accessibilité',
    loadingParkingArea: 'Stationnement',
    deliveryAddress: 'Adresse',
    deliveryHousing: 'Logement',
    deliveryFloor: 'Étages',
    deliveryElevator: 'Ascenseur',
    deliveryFurnitureTransport: 'Accessibilité',
    deliveryParkingArea: 'Stationnement',
    serviceOfferDates: 'Date',
    serviceOfferServices: 'Services',
    serviceOfferAssurance: 'Assurance',
    furnituresRooms: 'Pièces',
    furnituresInventory: 'Meubles',
    furnituresBoxConfig: 'Cartons à déménager',
    furnituresBoxDelivery: 'Cartons à fournir',
    validateConfirm: 'Récapitulatif',
  },
};
